// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__34VkU","header":"ReportDetails_header__srssp","title":"ReportDetails_title__pnPxo","left":"ReportDetails_left__1pdBq"};